import './ShowBar.css';

function ShowBar({ nonLinear, name, description, value, max, color1, color2, animation, hideMax }) {

  const heights = new Array(max);
  if (nonLinear) {
    for (let i = 1; i <= max; i++) {
      heights[max-i] = i*i;
    }
  } else {
    heights.fill(1);
  }

  return (
    <>
      <div className='showbar' title={description}>
        <div>{value}{!hideMax && '/' + max}</div>
        <div className={'actualbar' + (max >= 30 ? ' compact' : '')}>
          {
            heights.map((height, i) => {
              if ((max - i) <= value) {
                return <div key={i} className='valuebar' style={{ borderColor: color1, backgroundColor: color2, flexGrow: height }}></div>;
              }
              return <div key={i} className='emptybar' style={{ borderColor: animation ? color1 : 'black', flexGrow: height, animationName: (max-i) === (value+1) ? animation : undefined }}></div>;
            })
          }
        </div>
        <div>{name}</div>
      </div>
    </>
  );
}

export default ShowBar;
